export default __webpack_public_path__ + "static/media/error404.cdb84da9.jpg";